































































































































































































































































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';
import { decimalBrMask, calculoIdadeGestacional } from '../../utils/functions';

import { Consulta } from '../../../../back/src/entity/Consulta';
import { Exame } from '../../../../back/src/entity/Exame';
import { PressaoArterial } from '../../../../back/src/entity/PressaoArterial';
import { ResultadoDeExame } from '../../../../back/src/entity/ResultadoDeExame';
import {
  apresentacaoFetalItems,
  posicaoFetalItems,
  edemaItems,
  edemaStrings,
  movimentoFetalItems,
} from '../../utils/constants';
import { Edema, ConsultaPutFormData, PressaoArterialForm } from '../../../../back/src/types';

import Confirmar from '../Confirmar.vue';
import CustomDialog from '../CustomDialog.vue';
import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import ThePressoesArteriaisDadosDialog from '../pressoes_arteriais/ThePressoesArteriaisDadosDialog.vue';
import ThePressoesArteriaisFormDialog from '../pressoes_arteriais/ThePressoesArteriaisFormDialog.vue';
import PressaoArterialAlert from '../pressoes_arteriais/PressaoArterialAlert.vue';
import ResultadosDeExamesFormPedido from '../resultados_de_exames/ResultadosDeExamesFormPedido.vue';
import ResultadosDeExamesFormRemover from '../resultados_de_exames/ResultadosDeExamesFormRemover.vue';

export default Vue.extend({
  name: 'TheConsultasFormIndividual',
  components: {
    Confirmar,
    CustomDialog,
    IfEmptyTextPrintNA,
    ThePressoesArteriaisDadosDialog,
    ThePressoesArteriaisFormDialog,
    PressaoArterialAlert,
    ResultadosDeExamesFormPedido,
    ResultadosDeExamesFormRemover,
  },
  props: {
    consulta: {
      type: Object as () => Consulta,
      default: null,
    },
    exames: {
      type: Array as () => Exame[],
    },
    obsPreNatal: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: {
        form: true,
        submit: false,
      },
      dialogPressaoArterialDados: false,
      dialogPressaoArterialForm: false,
      pressaoArterialSelecionada: null,
      dialogResultadoDeExamePedido: false,
      dialogRemoveResultadoDeExame: false,
      resultadoSelecionado: null,
      form: {
        pesoKg: null,
        freqCardMaterna: null,
        alturaUterina: null,
        edema: null,
        movimentoFetal: null,
        batCardFetal1: null,
        apresFetal1: null,
        posicaoFetal1: null,
        batCardFetal2: null,
        apresFetal2: null,
        posicaoFetal2: null,
        queixasCondutas: null,
        queixasCondutasPrivada: false,
        mamas: null,
        pressoesArteriais: [] as PressaoArterial[],
      },
      items: {
        apresentacaoFetal: apresentacaoFetalItems,
        posicaoFetal: posicaoFetalItems,
        edema: edemaItems,
        movimentoFetal: movimentoFetalItems,
      },
      headers: [
        {
          value: 'id',
          text: 'Exame ',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'observacoes',
          text: 'Observações ',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'actions',
          text: 'Remover ',
          class: 'text-no-wrap',
          sortable: false,
          width: '0',
          align: 'center',
        },
      ],
      Edema,
    };
  },
  computed: {
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    vColClass(): string {
      return 'pt-1 pb-2';
    },
    vColLabelClass(): string {
      return 'pt-1 pb-2 mb-1';
    },
    actionsClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex justify-space-between pt-0 pb-2';
      }
      return 'd-flex justify-end pt-0 pb-2';
    },
    colorEdema1(): string {
      switch (this.form.edema) {
        case Edema['1+']:
        case Edema['2+']:
        case Edema['3+']:
        case Edema['4+']:
          return 'primary';
        default:
          return 'grey';
      }
    },
    colorEdema2(): string {
      switch (this.form.edema) {
        case Edema['2+']:
        case Edema['3+']:
        case Edema['4+']:
          return 'primary';
        default:
          return 'grey';
      }
    },
    colorEdema3(): string {
      switch (this.form.edema) {
        case Edema['3+']:
        case Edema['4+']:
          return 'primary';
        default:
          return 'grey';
      }
    },
    colorEdema4(): string {
      switch (this.form.edema) {
        case Edema['4+']:
          return 'primary';
        default:
          return 'grey';
      }
    },
    pesoGramas(): number | null {
      if (!this.form.pesoKg) {
        return null;
      }
      const pesoKg = Number(this.form.pesoKg.replace(',', '.'));
      if (pesoKg > 0) {
        return Math.round(pesoKg * 1000);
      }
      return null;
    },
    gestante(): boolean {
      return !!this.consulta.gestacao;
    },
    aliasPaciente(): string {
      return this.gestante ? `Gestante (IG - ${this.idadeGestacional(this.consulta)})` : 'Paciente';
    },
    labelFreqCardiaca(): string {
      return this.gestante ? 'Freq. cardíaca materna (bpm)' : 'Freq. cardíaca (bpm)';
    },
    gemelar(): boolean {
      return this.gestante ? this.consulta.gestacao.gestacao_gemelar : false;
    },
    flagPa(): boolean {
      return this.gestante ? this.consulta.gestacao.flag_pa : false;
    },
    resultadosDeExames(): ResultadoDeExame[] {
      return _.filter(
        this.consulta.resultados_de_exames as ResultadoDeExame[],
        resultado => (!resultado.deleted),
      );
    },
  },
  watch: {
    form: {
      handler() {
        this.$emit('atualizaForm', this.form);
      },
      deep: true,
    },
  },
  mounted() {
    this.preencheForm();
  },
  methods: {
    preencheForm() {
      this.loading.form = true;
      if (this.consulta) {
        this.form.pesoKg = this.consulta.peso_gramas
          ? (this.consulta.peso_gramas / 1000).toFixed(1)
          : null;
        this.pesoKgMask();
        this.form.freqCardMaterna = this.consulta.freq_card_materna;
        this.form.alturaUterina = this.consulta.altura_uterina;
        this.form.edema = this.consulta.edema;
        this.form.movimentoFetal = this.consulta.movimento_fetal;
        this.form.batCardFetal1 = this.consulta.bat_card_fetal1;
        this.form.apresFetal1 = this.consulta.apres_fetal1;
        this.form.posicaoFetal1 = this.consulta.posicao_fetal1;
        this.form.batCardFetal2 = this.consulta.bat_card_fetal2;
        this.form.apresFetal2 = this.consulta.apres_fetal2;
        this.form.posicaoFetal2 = this.consulta.posicao_fetal2;
        this.form.mamas = this.consulta.mamas;
        this.form.queixasCondutas = this.consulta.queixas_condutas;
        this.form.queixasCondutasPrivada = this.consulta.queixas_condutas_privada;
        this.form.pressoesArteriais = _.map(
          _.sortBy(
            this.consulta.pressoes_arteriais as PressaoArterial[],
            el => (el.created),
          ) as PressaoArterial[],
          (el) => {
            const pressaoArterialForm: PressaoArterialForm = {
              id: el.id ? el.id : null,
              max: el.max,
              min: el.min,
              observacoes: el.observacoes,
              created: el.created ? el.created : null,
              remover: false,
              nome_criador: el.usuario_created_by ? el.usuario_created_by.nome : '',
            };
            return pressaoArterialForm;
          },
        );
      }
      this.loading.form = false;
    },
    idadeGestacional() {
      return calculoIdadeGestacional(
        this.consulta.gestacao,
        this.consulta.started,
        true,
      );
    },
    pesoKgMask() {
      if (!this.form.pesoKg) return;
      this.form.pesoKg = decimalBrMask(this.form.pesoKg, 1);
    },
    edema(edema: Edema): string {
      if (_.has(edemaStrings, edema)) {
        return edemaStrings[edema];
      }
      return '';
    },
    clickEdema(edema: Edema) {
      if (this.form.edema === edema) {
        this.form.edema = null;
      } else {
        this.form.edema = edema;
      }
    },
    // PRESSAO ARTERIAL
    abreDialogPressaoArterial(pressaoArterial: PressaoArterial) {
      this.pressaoArterialSelecionada = pressaoArterial;
      this.dialogPressaoArterialDados = true;
    },
    colorPressaoArterial(pressaoArterialForm: PressaoArterialForm) {
      if (pressaoArterialForm.remover) {
        return 'error';
      }
      if (pressaoArterialForm.id) {
        return 'primary';
      }
      return 'success';
    },
    colorInfoPressaoArterial(pressaoArterialForm: PressaoArterialForm) {
      if (pressaoArterialForm.remover) {
        return 'error';
      }
      if (pressaoArterialForm.observacoes) {
        return 'primary';
      }
      return 'grey';
    },
    adicionaPressaoArterial(pressaoArterialForm: PressaoArterialForm) {
      this.form.pressoesArteriais.push({
        id: null,
        max: pressaoArterialForm.max,
        min: pressaoArterialForm.min,
        observacoes: pressaoArterialForm.observacoes,
        created: new Date(),
        remover: false,
        nome_criador: this.$store.getters.usuario.nome,
      });
    },
    removerPressaoArterial(pressaoArterial: PressaoArterialForm) {
      if (pressaoArterial.id) {
        const index = _.findIndex(
          this.form.pressoesArteriais as PressaoArterialForm[],
          el => (el.id === pressaoArterial.id),
        );
        if (index >= 0) {
          this.$set(this.form.pressoesArteriais[index], 'remover', true);
        }
      } else {
        _.pull(this.form.pressoesArteriais, pressaoArterial);
      }
      this.dialogPressaoArterialDados = false;
    },
    desfazerRemocaoPressaoArterial(pressaoArterial: PressaoArterialForm) {
      if (pressaoArterial.id) {
        const index = _.findIndex(
          this.form.pressoesArteriais as PressaoArterialForm[],
          el => (el.id === pressaoArterial.id),
        );
        if (index >= 0) {
          this.$set(this.form.pressoesArteriais[index], 'remover', false);
        }
      }
      this.dialogPressaoArterialDados = false;
    },
    // PEDIDOS DE EXAME
    novoResultadoDeExame(resultadoDeExame: ResultadoDeExame) {
      this.$emit('novoResultadoDeExame', resultadoDeExame);
      this.dialogResultadoDeExamePedido = false;
    },
    removeResultadoDeExame(resultadoDeExame: ResultadoDeExame) {
      this.$emit('removeResultadoDeExame', resultadoDeExame);
      this.dialogRemoveResultadoDeExame = false;
    },
    removePedidoDeExame(resultadoDeExame: ResultadoDeExame) {
      this.resultadoSelecionado = resultadoDeExame;
      this.dialogRemoveResultadoDeExame = true;
    },
    // eslint-disable-next-line func-names
    desfazerDebounce: _.debounce(async function () { await this.desfazer(); }, 200),
    async desfazer() {
      if (await this.confirmar.open(
        'Desfazer edição',
        'Tem certeza que deseja desfazer a edição?\nOs dados alterados serão perdidos.',
      ) === false) {
        return;
      }
      this.$emit('desfazer');
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading.submit = true;
      const formData: ConsultaPutFormData = {
        id: this.consulta.id,
        peso_gramas: this.pesoGramas ? this.pesoGramas : null,
        altura_uterina: this.form.alturaUterina ? this.form.alturaUterina : null,
        freq_card_materna: this.form.freqCardMaterna ? this.form.freqCardMaterna : null,
        movimento_fetal: this.form.movimentoFetal ? this.form.movimentoFetal : null,
        edema: this.form.edema ? this.form.edema : null,
        mamas: this.form.mamas ? this.form.mamas : null,
        queixas_condutas: this.form.queixasCondutas ? this.form.queixasCondutas : null,
        queixas_condutas_privada: this.form.queixasCondutasPrivada
          ? this.form.queixasCondutasPrivada
          : false,
        bat_card_fetal1: this.form.batCardFetal1 ? this.form.batCardFetal1 : null,
        apres_fetal1: this.form.apresFetal1 ? this.form.apresFetal1 : null,
        posicao_fetal1: this.form.posicaoFetal1 ? this.form.posicaoFetal1 : null,
        bat_card_fetal2: this.form.batCardFetal2 ? this.form.batCardFetal2 : null,
        apres_fetal2: this.form.apresFetal2 ? this.form.apresFetal2 : null,
        posicao_fetal2: this.form.posicaoFetal2 ? this.form.posicaoFetal2 : null,
        pressoes_arteriais: this.form.pressoesArteriais,
      };
      try {
        const response = await Requester.consulta.alteraConsulta(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          this.loading.submit = false;
          return false;
        }
        this.$emit('atualizaConsulta', response.data);
        this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Dados salvos com sucesso. Não se esqueça de finalizar a consulta.' });
        this.loading.submit = false;
        return true;
      } catch (err) {
        this.$root.$emit('requestError', err);
        this.loading.submit = false;
        return false;
      }
    },
  },
});
